import { useState, useEffect } from "react";
import { Link } from "react-router-dom";
import axios from "axios";
import { API } from "../App";
import PageHero, { HERO_IMAGES } from "../components/PageHero";
import StudentForm from "../components/StudentForm";
import { ArrowLeft, Users } from "lucide-react";

export default function DiventaStudente() {
  const [chiSiamo, setChiSiamo] = useState([]);

  useEffect(() => {
    axios.get(`${API}/content/chi-siamo`).then(r => setChiSiamo(r.data)).catch(() => {});
    window.scrollTo(0, 0);
  }, []);

  return (
    <div className="page-container" data-testid="diventa-studente-page">
      <PageHero image={HERO_IMAGES.home} kicker="GoldVision" title="Diventa Studente" subtitle="Compila il form: in base alle tue risposte capiremo se potrai collaborare e diventare studente" />
      <div className="container py-8 relative">
        <Link to="/" className="inline-flex items-center gap-2 mb-6 px-4 py-2 rounded-lg transition-all hover:bg-white/5" style={{ color: "var(--mm-gold)" }} data-testid="back-home">
          <ArrowLeft size={20} /><span style={{ fontFamily: "'Space Grotesk', sans-serif" }}>Torna alla Home</span>
        </Link>

        {/* Form in cima */}
        <div className="max-w-2xl mx-auto mb-14">
          <StudentForm formId="top" />
        </div>

        {/* Chi Siamo */}
        {chiSiamo.length > 0 && (
          <div className="max-w-3xl mx-auto mb-14">
            <div className="flex items-center gap-3 mb-8">
              <Users size={24} style={{ color: "var(--mm-gold)" }} />
              <h2 className="text-2xl sm:text-3xl font-bold gold-text" style={{ fontFamily: "'Space Grotesk', sans-serif" }}>
                Chi Siamo
              </h2>
            </div>
            <div className="space-y-6">
              {chiSiamo.map((item, i) => (
                <div key={item.id} className="glass-card p-6" data-testid={`ds-chi-siamo-${i}`}>
                  {item.title && (
                    <h3 className="text-lg font-bold mb-2" style={{ fontFamily: "'Space Grotesk', sans-serif", color: "var(--mm-gold)" }}>{item.title}</h3>
                  )}
                  <p className="text-sm sm:text-base leading-relaxed whitespace-pre-line" style={{ color: "var(--mm-text-secondary)" }}>{item.content}</p>
                </div>
              ))}
            </div>
          </div>
        )}

        {/* Form in fondo (sostituisce "Entra nella community") */}
        <div className="max-w-2xl mx-auto">
          <div className="text-center mb-6">
            <h2 className="text-2xl sm:text-3xl font-bold gold-text" style={{ fontFamily: "'Space Grotesk', sans-serif" }} data-testid="ds-bottom-title">
              Pronto a iniziare?
            </h2>
            <p className="text-sm mt-2" style={{ color: "var(--mm-text-secondary)" }}>
              Invia la tua candidatura ora
            </p>
          </div>
          <StudentForm formId="bottom" />
        </div>
      </div>
    </div>
  );
}
